var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("list-item", {
    attrs: {
      booking: _vm.booking,
      link: { name: "vetting.show", params: { id: _vm.booking.id } },
    },
    scopedSlots: _vm._u(
      [
        {
          key: "categories",
          fn: function () {
            return [
              _vm.bookingOpportunityName
                ? _c("div", { staticClass: "list-item__category" }, [
                    _c("span", { staticClass: "label label-info" }, [
                      _vm._v(_vm._s(_vm.bookingOpportunityName)),
                    ]),
                  ])
                : _vm._e(),
            ]
          },
          proxy: true,
        },
        {
          key: "status",
          fn: function () {
            return [
              _vm.booking.urgent
                ? _c("div", { staticClass: "spacer-b-2" }, [
                    _c("span", { staticClass: "label label-danger" }, [
                      _vm._v("Urgent"),
                    ]),
                  ])
                : _vm._e(),
            ]
          },
          proxy: true,
        },
        _vm.userCanSeeBudget
          ? {
              key: "hero",
              fn: function () {
                return [
                  _vm._v(
                    "\n    " +
                      _vm._s(
                        _vm._f("nullable")(
                          _vm._f("currency")(
                            _vm.bookingGrandTotalBudget,
                            _vm.booking.local_currency
                              ? _vm.booking.local_currency
                              : _vm.booking.currency
                          )
                        )
                      ) +
                      "\n  "
                  ),
                ]
              },
              proxy: true,
            }
          : null,
        {
          key: "admin",
          fn: function () {
            return [
              _vm.booking.local_currency
                ? _c("div", { staticClass: "spacer-b-1 flex flex-row" }, [
                    _c("i", { staticClass: "fa fa-info-circle spacer-r-1" }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "Estimated conversion to " +
                          _vm._s(_vm.booking.local_currency) +
                          ". Actual amount may differ due to fluctuating conversion rates."
                      ),
                    ]),
                  ])
                : _vm._e(),
            ]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }